import { mutatorAction } from "satcheljs";
import { ReorderTagsPanelViewState } from "sh-application/store/schema/ReorderTagsPanelViewState";

export default mutatorAction("SET_IS_SQUEEZED",
    function setReorderTagsContentIsSqueezed(viewState: ReorderTagsPanelViewState, isSqueezed: boolean) {
        viewState.isSqueezed = isSqueezed;
    }
);